<template>
	<aside class="provider" v-if="data">
    <a :href="data.clinicUrl" class="provider__link">
	      <p class="location-name">{{ locationName }}</p>
        <p class="location">{{ data.city.toUpperCase() }}, {{ data.state.toUpperCase() }}</p>
        <img class="image" :alt="data.hcpName" :src="data.imageUrl" />
        <div class="who">
            <label class="name">{{ data.hcpName }}</label>
            <label class="title">Hearing Care Practitioner</label>
        </div>
        <div class="information">
            <p class="distance" v-if="milesAway"><strong>{{ milesAway }}</strong> Miles Away</p>
            <template v-if="nextAvailableAppointment">
                <p class="nextAppointment">Next Available Appointment</p>
                <p class="appointmentTime">{{ nextAvailableAppointment }}</p>
            </template>
            <template v-else>
                <p class="nextAppointment">&nbsp;</p>
                <p class="appointmentTime">&nbsp;</p>
            </template>
        </div>
    </a>
		<div class="footer-actions">
      <a class="btn-beltone dark" :href="`tel:${this.helpers().callCenterPhoneNumber()}`" target="_top">Call {{ this.helpers().callCenterPhoneNumber() }} to Schedule</a>
			<button @click="showScheduling(data.clinicUrl)" class="btn-beltone">Book Online</button>
		</div>
	</aside>
</template>

<script>
import {mapMutations, mapState} from 'vuex';
import Services from '../../mixins/services';
import moment from "moment";

export default {
	mixins: [Services],
	props: ['data'],
	components: {
	},
	data: function () {
		return {
		}
	},
	computed: mapState({
		geoLocation: state => state.LocationSearch.geoLocation,
		globals: state => state.LocationSearch.globals,
		milesAway() {
			return Math.round(this.data.milesAway * 100) / 100
		},
		nextAvailableAppointment() {
			if (this.data.nextAvailableAppointment === '0001-01-01T00:00:00') {
				return null;
			}
			let _dateTime = this.data.nextAvailableAppointment;
			return moment(_dateTime).format('dddd, MMM. Do @ h:mm a');
		},
		locationName() {
      let name = this.data.name?.toUpperCase().replace(/,/g, '').trim();
      let city = this.data.city?.toUpperCase().replace(/,/g, '').trim();
      let state = this.data.state?.toUpperCase().replace(/,/g, '').trim();
      let cityState = `${city} ${state}`.replace(/\s+/g, ' ').trim();

      if (!name) {
        return "";
      }
      if (name === city || name === cityState) {
        return "";
      }
      return this.data.name?.toUpperCase();
		}
	}),
	methods: {
    ...mapMutations('OnlineScheduling', { setStateValue: 'setStateValue' }),
    showScheduling(url) {
      const segments = url.split('/').filter(Boolean);
      this.setStateValue({ key: 'clinicUrl', value: segments[segments.length - 1] });      
    }
	},
	mounted() {

	},
	created() {
	}
}
</script>
